var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3055 6.83006L20.6887 6.93086L20.7645 7.39463L21.2311 7.45061L21.3055 6.83006ZM20.8 15.1999L20.8 14.5749L20.175 14.575V15.1999H20.8ZM20.8 15.2V15.825H21.425V15.2H20.8ZM7.85304 4.59774L7.68523 5.1998L8.16697 5.33407L8.40363 4.8935L7.85304 4.59774ZM21.9223 6.72927C21.3149 3.01186 18.0894 0.175003 14.2001 0.175003V1.425C17.467 1.425 20.1784 3.8082 20.6887 6.93086L21.9223 6.72927ZM25.6249 10.9999C25.6249 8.53128 23.7715 6.49644 21.38 6.20951L21.2311 7.45061C23.0019 7.66307 24.3749 9.17162 24.3749 10.9999H25.6249ZM20.8 15.8249C23.4647 15.8249 25.6249 13.6647 25.6249 10.9999H24.3749C24.3749 12.9743 22.7744 14.5749 20.8 14.5749L20.8 15.8249ZM21.425 15.2V15.1999H20.175V15.2H21.425ZM14.2001 15.825H20.8V14.575H14.2001V15.825ZM6.4 15.825H14.2001V14.575H6.4V15.825ZM0.375 9.8C0.375 13.1275 3.07248 15.825 6.4 15.825V14.575C3.76284 14.575 1.625 12.4372 1.625 9.8H0.375ZM6.4 3.775C3.07248 3.775 0.375 6.47249 0.375 9.8H1.625C1.625 7.16284 3.76284 5.025 6.4 5.025V3.775ZM8.02084 3.99569C7.50441 3.85175 6.96066 3.775 6.4 3.775V5.025C6.84615 5.025 7.27703 5.08602 7.68523 5.1998L8.02084 3.99569ZM14.2001 0.175003C11.215 0.175003 8.62135 1.84668 7.30244 4.30198L8.40363 4.8935C9.51342 2.82748 11.6934 1.425 14.2001 1.425V0.175003Z",
    fill: "#0070D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.79994V11.5999",
    stroke: "#0070D2",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 8L12.9999 5.6L10.5999 8",
    stroke: "#0070D2",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.23a7a15a3e4d3f741cebee98cc175a29.svg";
export { ForwardRef as ReactComponent };